module.exports = __webpack_public_path__ + "img/public-security.58f55c5c.png";